import React from 'react';
import styles from '../mortgage.module.scss';

interface SliderStepInterface {
  title: string;
  customClass: string;
  inpuRangeLabel: string;
  max: number;
  min: number;
  onClick: () => void;
  onChange: (string) => void;
  value: number;
}

export const SliderStep: React.FC<SliderStepInterface> = ({
  customClass,
  inpuRangeLabel,
  max,
  min,
  onChange,
  onClick,
  title,
  value,
}) => {
  const progress = max > min ? ((value - min) / (max - min)) * 100 : 0;

  return (
    <section className={`step ${customClass}`}>
      <h2 className={`${styles.heading} mx-auto text-center font-bold`}>{title}</h2>
      <div className="mb-5 text-[24px] font-bold tracking-tight text-bzblue-1000 sm:mb-6 sm:text-[32px]">
        {inpuRangeLabel}
      </div>
      <input
        aria-label={title}
        aria-valuetext={inpuRangeLabel}
        className={`${styles.slider} mx-auto block w-full max-w-[480px]`}
        max={max}
        min={min}
        onChange={e => {
          onChange(e.target.value);
        }}
        style={{ '--slider-progress': `${progress}%` } as React.CSSProperties}
        type="range"
        value={value}
      />
      <button
        className={`${styles.cta} inline-flex items-center justify-center font-bold uppercase`}
        onClick={onClick}
        type="button"
      >
        NEXT
        <span aria-hidden="true" className="text-base leading-none">
          &rarr;
        </span>
      </button>
    </section>
  );
};
